import React, { useEffect, useState } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {bindActionCreators} from 'redux'
import {actionFacturacionCliente, actionComprobanteRetencionCliente, actionsClienteReceptor, actionGeneral} from '../../../../actions/action-creators'
import {isNullOrEmpty} from '../../../../utils/strings.utils'
import {getMinDateRetroactiva} from '../../../../utils/stringDate'
import InputPhone from '../../../../components/Inputs/InputPhone'
import SearchSelect from '../../../../components/Inputs/SearchSelect'
import ModalInfoCliente from '../../../EmitirFactura/Components/GeneracionFactura/Modals/ModalInfoCliente'
import { comprobanteRetencionInitialState, comprobanteRetencionInitialState2 } from '../../../../initital-state/comprobanteRetencion.state'
import InputChips from '../../../OtrosDocumentos/Components/InputChips'

const CREDatosCliente = () => {
  const {fecha_actual} = useSelector((state: State) => state.general)
  const config = useSelector((state: State) => state.userLogin.config)
  const formCliente = useSelector((state: State) => state.comprobanteRetencion.formCliente)
  const errors = useSelector((state: State) => state.comprobanteRetencion.errorsFormCliente)
  const {departamentos, municipios, actividadesEconomicas} = useSelector((state: State) => state.catalogos)
  const loader = useSelector((state: State) => state.general.loader)
  const modalInfo = useSelector((state: State) => state.facturacion.modals.activeInfoCliente)
  const [catalogueActividadEconomica, setCatalogueActividadEconomica] = useState(actividadesEconomicas.map((tipo) => ({...tipo,codigo_nombre: `${tipo.codigo} - ${tipo.valor}`})))
  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionComprobanteRetencionCliente, dispatch)
  const accionesClienteReceptor = bindActionCreators(actionsClienteReceptor, dispatch)
  const accionesFacturacion = bindActionCreators(actionFacturacionCliente, dispatch)
  const {getFechaHora} = bindActionCreators(actionGeneral, dispatch)

  useEffect(() => {
    getFechaHora()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])  
  
  useEffect(() => {
    if (actividadesEconomicas.length > 0) setCatalogueActividadEconomica(actividadesEconomicas.map((tipo) => ({...tipo,codigo_nombre: `${tipo.codigo} - ${tipo.valor}`})))
  }, [actividadesEconomicas])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => {
    acciones.comprobanteRetencionFormClienteHandleChangeInput(e)
    acciones.comprobanteRetencionFormClienteOnBlur(e)
  }
  
  const onBlurClient = async (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>)  => {
    acciones.comprobanteRetencionFormClienteOnBlur(e)
    if(formCliente.tipoDocumento && formCliente.numId) {
      const user = await accionesClienteReceptor.buscarClienteReceptor(formCliente)
      if(user !== null) {
        dispatch(accionesFacturacion.facturacionInfoCliente(user))
        dispatch(accionesFacturacion.facturacionOpenModalCliente())
      }
    }
  }
  
  const confirmarDatos = (data:any) => {
    dispatch(acciones.comprobanteRetencionFormClienteHandleChange({...data, chipsEmail: data?.email ? data.email.split(',').filter((e: string) => e.trim()) : [], email: ''}));
    dispatch(acciones.comprobanteRetencionFormClienteAddError(comprobanteRetencionInitialState2.errorsFormCliente))
  }

  const cancelar = () => {
    dispatch(acciones.comprobanteRetencionFormClienteHandleChange({...comprobanteRetencionInitialState.formCliente, numId: formCliente.numId}));
    dispatch(acciones.comprobanteRetencionFormClienteAddError(comprobanteRetencionInitialState2.errorsFormCliente))
  }
    
  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec6-0b1e6fa6' className='w-layout-cell'>
      {modalInfo && <ModalInfoCliente confirmarDatos={(datos:any) => confirmarDatos(datos)} cancelar={() => cancelar()} />}
      <div className='card w-form'>
        <form className='form-content' data-wf-page-id='64b58c72be2b65200b1e6fa6' data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc' autoComplete='off'>
          <div>
            <h3 className='card-title l'>Datos del Cliente</h3>
            <p style={{color: '#019FC5', margin: '1% 0', fontWeight: 'bold'}}>Solamente es permitido receptor gran contribuyente</p>
            <div className='form-separator'></div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='fecha' className='field-label m'>Fecha de factura</label>
              <input autoFocus autoComplete='off' type='date' className='m text-field w-input' name='fecha' data-name='' id='fecha'
                value={config?.facturacion_retroactiva ? formCliente.fecha : (fecha_actual?.FechaInput || formCliente.fecha)}
                readOnly={!config?.facturacion_retroactiva}
                min={config?.facturacion_retroactiva && config?.dias_facturacion_retroactiva && fecha_actual?.FechaInput ? getMinDateRetroactiva(config.dias_facturacion_retroactiva, fecha_actual.FechaInput) : '2000-01-01'}
                max={config?.facturacion_retroactiva ? fecha_actual?.FechaInput : undefined}
                onChange={handleChange} onBlur={acciones.comprobanteRetencionFormClienteOnBlur} />
              {errors.fecha && <p className='alert s'>{errors.fecha}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='numId' className='field-label m'>NIT<span style={{color: 'red'}}>*</span></label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='numId'
                data-name='numId'
                placeholder={`Número de ${formCliente.nombreTipoDocumento || 'Identificación'}`}
                id='numId'
                disabled={formCliente.tipoDocumento ? false : true}
                maxLength={20}
                value={formCliente.numId}
                onChange={handleChange}
                onBlur={onBlurClient}
              />
              {errors.numId && <p className='alert s'>{errors.numId}</p>}
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='nombre' className='field-label m'>Nombre del cliente<span style={{color: 'red'}}>*</span></label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='nombre'
                data-name=''
                placeholder='Nombre del cliente'
                id='nombre'
                disabled={formCliente.tipoDocumento ? false : true}
                maxLength={250}
                value={formCliente.nombre}
                onChange={handleChange}
                onBlur={acciones.comprobanteRetencionFormClienteOnBlur}
              />
              {errors.nombre && <p className='alert s'>{errors.nombre}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='departamento' className='field-label m'>Departamento<span style={{color: 'red'}}>*</span></label>
              <SearchSelect
                defaultValue={null}
                data={departamentos?.map((dep) => ({...dep, codigo_nombre: `${dep.codigo} - ${dep.valor}`}))}
                value={formCliente.departamento}
                keyNameText='codigo_nombre'
                keyNameValue='codigo'
                placeholder='Departamento'
                disabled={loader ? true : formCliente.tipoDocumento ? false : true}
                name='departamento'
                onChange={(value: any) => {handleChange({target: {value: value?.value, name: 'departamento'},})}}
              />
              {errors.departamento && <p className='alert s'>{errors.departamento}</p>}
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='municipio' className='field-label m'>Municipio<span style={{color: 'red'}}>*</span></label>
              <SearchSelect
                defaultValue={null}
                value={formCliente.municipio}
                data={municipios?.map((mun) => ({...mun, codigo_nombre: `${mun?.codigo} - ${mun?.valor}`}))}
                keyNameText='codigo_nombre'
                keyNameValue='codigo'
                placeholder='Municipio'
                disabled={isNullOrEmpty(formCliente.departamento) ? true : formCliente.tipoDocumento ? false : true}
                name='municipio'
                onChange={(value: any) => {handleChange({target: {value: value?.value, name: 'municipio'},})}}
              />
              {errors.municipio && <p className='alert s'>{errors.municipio}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='direccion' className='field-label m'>Dirección<span style={{color: 'red'}}>*</span></label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='direccion'
                data-name=''
                placeholder='Dirección'
                id='direccion' 
                disabled={isNullOrEmpty(formCliente.municipio) ? true : false}
                maxLength={200}
                value={formCliente.direccion}
                onChange={handleChange}
                onBlur={acciones.comprobanteRetencionFormClienteOnBlur}
              />
              {errors.direccion && <p className='alert s'>{errors.direccion}</p>}
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <InputChips
              maxChips={5} chips={formCliente.chipsEmail} setChips={(chipsEmail: Array<string>) => handleChange({target: {value: chipsEmail, name: 'chipsEmail'}})} 
              maxLength={100} onBlur={acciones.comprobanteRetencionFormClienteOnBlur} name='email' placeholder='Correo electrónico' 
              label = 'Correo electrónico' type='email' value={formCliente.email} error={errors.email} onChange={handleChange}
              disabled={formCliente.tipoDocumento ? false : true}
            />
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='telefono' className='field-label m'>Teléfono celular<span style={{color: 'red'}}>*</span></label>
              <InputPhone
                className='m text-field w-input'
                name='telefono'
                disabled={formCliente.tipoDocumento ? false : true}
                value={formCliente.telefono}
                onChange={acciones.comprobanteRetencionFormClienteHandleChangeInputPhone}
                onBlur={acciones.comprobanteRetencionFormClienteOnBlur}
              />
              {errors.telefono && <p className='alert s'>{errors.telefono}</p>}
            </div>
            <div className='label-input'>
              <label htmlFor='actividad' className='field-label m'>
                Actividad<span style={{color: 'red'}}>*</span>
              </label>
              <SearchSelect
                defaultValue={null}
                disabled={false}
                placeholder='Actividad económica'
                value={formCliente.actividad}
                name='actividad'
                data={catalogueActividadEconomica}
                keyNameText='codigo_nombre'
                keyNameValue='codigo'
                onChange={(value: any) => {handleChange({target: {value: value?.value, name: 'actividad'},})}}
              />
              {errors.actividad && <p className='alert s'>{errors.actividad}</p>}
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='nrc' className='field-label m'>NRC<span style={{color: 'red'}}>*</span></label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='nrc'
                data-name='nrc'
                placeholder="NRC"
                id='nrc'
                maxLength={7}
                value={formCliente.nrc}
                onChange={handleChange}
                onBlur={acciones.comprobanteRetencionFormClienteOnBlur}
              />
              {errors.nrc && <p className='alert s'>{errors.nrc}</p>}
            </div>
            <div className='label-input'>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default CREDatosCliente
